import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VideoGeneratorLayer from "../components/VideoGeneratorLayer";


const VideoGeneratorPage = () => {
  return (
    <>

      {/* Breadcrumb */}
      <Breadcrumb title="Video Generator" />

      {/* VideoGeneratorLayer */}
      <VideoGeneratorLayer />


    </>
  );
};

export default VideoGeneratorPage; 
